export default "__VITE_ASSET__3VTC1aHC__"